import { Typography, Box, IconButton, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { AssetFieldMapping } from '../../../store/OutsideInventory';

interface FieldMappingStepProps {
  mappings: AssetFieldMapping[];
  onRemoveMapping: (portalFieldKey: string) => void;
}

export const FieldMappingStep = ({ mappings, onRemoveMapping }: FieldMappingStepProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="body2"
        sx={{ mb: 2 }}>
        The following fields will be mapped from the Salesforce Asset to the outside inventory record. You may remove
        optional mappings, but required fields cannot be deleted.
      </Typography>
      <Table
        size="small"
        data-testid="field-mapping-table"
        sx={{ '& td, & th': { border: 1, borderColor: 'divider' } }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Salesforce Asset Field</strong>
            </TableCell>
            <TableCell>
              <strong>Outside Inventory Field</strong>
            </TableCell>
            <TableCell align="center">
              <strong>Remove</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mappings.map((mapping) => (
            <TableRow
              key={mapping.portalFieldKey}
              data-testid={`mapping-row-${mapping.portalFieldKey}`}>
              <TableCell>{mapping.assetField}</TableCell>
              <TableCell>{mapping.portalField}</TableCell>
              <TableCell align="center">
                {!mapping.required && (
                  <IconButton
                    size="small"
                    aria-label={`Remove ${mapping.portalField} mapping`}
                    data-testid={`delete-mapping-${mapping.portalFieldKey}`}
                    onClick={() => onRemoveMapping(mapping.portalFieldKey)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
